

















import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useUserPublicData from "@/hooks/useUserPublicData";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";
import { ROLES } from "@/const";
import BaseButton from "@/components/BaseButton";
import CustomScroll from "@/components/CustomScroll";
import CreatorsSliderItem from "./components/CreatorsSliderItem";

export default defineComponent({
  name: "CreatorsSlider",
  components: { BaseButton, CreatorsSliderItem, CustomScroll },
  props: {
    size: { type: Number },
  },
  setup(props) {
    const creatorsList = ref<UserPublicData[]>([]);
    const { loading, users, getFirstPage } = useUserPublicData(
      computed(() => ({
        role: [ROLES.CREATOR],
        sort: "IS_LIVE,DESC;IS_ONLINE,DESC;ID,DESC",
      })),
      props.size,
      userPublicDataFieldsWithStoryInfo()
    );

    const getData = async () => {
      await getFirstPage();
      creatorsList.value = users.value;
    };
    getData();

    return { loading, creatorsList };
  },
});
